import blob from './blob.svg'
const Right = () => {
    return (
        <div className="right">
       <div className="blog-section">
       <img src={blob} alt="blob shrink" />
       <h1>Shrink It</h1>
       </div>
        <h5 className="center-align">Easy Sign Up For </h5>
        <h5 className="center-align">Easier Control Of Your URLs.</h5>
        </div>
    );
}
 
export default Right;